// This file is auto-generated by @hey-api/openapi-ts
import { createClient, createConfig, } from "./client/index.js";
export const client = createClient(createConfig({ baseUrl: "/" }));
//# sourceMappingURL=client.gen.js.map